
    <td colspan="4">
        <span style="float: right; font-weight: bold">Total: </span>
    </td>
    <td class="overline" style="text-align: right;">
        @if (editMode) {
            <input type="text" class="form-control"
                    [style.color]="currentInvoice.previousFMVStatus"
                    style="width: 100%"
                    [(ngModel)]="currentInvoice.previousFMV"
                    (blur)="calculatedFieldChanged.emit(CalculatedFields.PreviousFMV)"
                    currencyMask
                    [options]="{ prefix: '', precision: '0', allowNegative: false }"/>
        }
        @if (!editMode) {
            <span [style.color]="currentInvoice.previousFMVStatus">
                {{ currentInvoice.previousFMV | number: '1.0-0' }}
            </span>
        }
    </td>
    @if (editMode) {
        <td class="overline override-button">
            @if (editMode && currentInvoice.previousFMVStatus === 'red') {
                <button type="button"
                        class="ace-btn btn-sm has-icon btn-primary btn-danger"
                        (click)="revertPreviousFMV(true)">
                    <i class="fa fa-undo"></i>
                </button>
            }
        </td>
    }
    <td class="overline" style="text-align: right;">
        @if (editMode) {
            <input type="text" class="form-control"
                    [style.color]="currentInvoice.invoiceFMVStatus"
                    style="width: 100%"
                    [(ngModel)]="currentInvoice.invoiceFMV"
                    (blur)="calculatedFieldChanged.emit(CalculatedFields.InvoiceFMV)"
                    currencyMask
                    [options]="{ prefix: '', precision: '0', allowNegative: false }"/>
        }
        @if (!editMode) {
            <span [style.color]="currentInvoice.invoiceFMVStatus">
                {{ currentInvoice.invoiceFMV | number: '1.0-0' }}
            </span>
        }
    </td>
    @if (editMode) {
        <td class="overline override-button">
            @if (editMode && currentInvoice.invoiceFMVStatus === 'red') {
                <button type="button"
                        class="ace-btn btn-sm has-icon btn-primary btn-danger"
                        (click)="revertInvoiceFMV(true)">
                    <i class="fa fa-undo"></i>
                </button>
            }
        </td>
    }
    <td class="overline"
        [style.color]="currentInvoice.fmvChangeStatus"
        style="text-align: right;">{{ currentInvoice.fmvChange | number: '1.0-0' }}
    </td>
    <td class="overline" style="text-align: right;">
        @if (editMode) {
            <input type="text" class="form-control"
                    [(ngModel)]="currentInvoice.displayTaxRate"
                    style="width: 100%"
                    [style.color]="currentInvoice.taxRateStatus"
                    (blur)="calculatedFieldChanged.emit(CalculatedFields.TaxRate)"
            />
        }
        @if (!editMode) {
            <span [style.color]="currentInvoice.taxRateStatus">
                {{ currentInvoice.displayTaxRate | number: '1.6-6' }}%
            </span>
        }
    </td>
    @if (editMode) {
        <td class="overline override-button">
            @if (editMode && currentInvoice.taxRateStatus === 'red') {
                <button type="button"
                        class="ace-btn btn-sm has-icon btn-primary btn-danger"
                        (click)="revertTaxRate(true)">
                    <i class="fa fa-undo"></i>
                </button>
            }
        </td>
    }
    <td class="overline" style="text-align: right;">
        @if (editMode) {
            <input type="text"
                    class="form-control"
                    [(ngModel)]="currentInvoice.savings"
                    style="width: 100%"
                    (blur)="calculatedFieldChanged.emit(CalculatedFields.Savings)"
                    currencyMask
                    [options]="{ allowNegative: false, precision: '2' }"
                    [style.color]="currentInvoice.savingsStatus"/>
        }
        @if (!editMode) {
            <span [style.color]="currentInvoice.savingsStatus">
                ${{ currentInvoice.savings | number: '1.2-2' }}
            </span>
        }
    </td>
    @if (editMode) {
        <td class="overline override-button">
            @if (editMode && currentInvoice.savingsStatus === 'red') {
                <button type="button"
                        class="ace-btn btn-sm has-icon btn-primary btn-danger"
                        (click)="revertSavings()">
                    <i class="fa fa-undo"></i>
                </button>
            }
        </td>
    }
    <td class="overline"></td>
